var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zm-checkbox-group",class:[_vm.size ? 'zm-checkbox-group--' + _vm.size : ''],attrs:{"role":"group"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }